import { atsApiQuery } from '..';

export const atsApplicationApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllJobs: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs`,
            method: 'get',
            params,
          };
        },
      }),
      getAllJobsList: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs/list`,
            method: 'get',
            params,
          };
        },
      }),
      // How many candidates sit in the job's stages. `copy_stages` refuses an
      // interview-plan import while any are there, so the UI checks first.
      getJobApplicationsCount: builder.query({
        transformResponse: (response) =>
          response?.data?.total_applications ?? 0,
        query: ({ jobId }) => {
          return {
            url: `ats_jobs/${jobId}/search/ats_applications/count`,
            method: 'post',
            data: {},
          };
        },
      }),
      // Hiring-team endpoints moved to React Query — see
      // `src/api/useGetHiringTeamOfJob`.
    };
  },
  overrideExisting: true,
});

export const {
  useGetAllJobsQuery,
  useGetAllJobsListQuery,
  useGetJobApplicationsCountQuery,
} = atsApplicationApi;
